export default "__VITE_ASSET__DKErDL26__"